var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66732 1.33333V6.66667H9.00065V5.33333V2.66667V1.33333H1.66732ZM10.334 2.09524V0.666667C10.334 0.298477 10.0355 0 9.66732 0H1.00065C0.632461 0 0.333984 0.298477 0.333984 0.666667V7.33333C0.333984 7.70152 0.632461 8 1.00065 8H9.66732C10.0355 8 10.334 7.70152 10.334 7.33333V5.90476L13.6673 7.33333V0.666667L10.334 2.09524ZM10.334 3.54586V4.45414L12.334 5.31128V2.68872L10.334 3.54586Z",
    fill: "#4D4E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.bd35e1f7331ea1f3ca20b8fd25f4598c.svg";
export { ForwardRef as ReactComponent };